import React, { useCallback } from 'react'
import { CopyItemCellStyles } from './Style'
import { IconButton, SvgIcon, Tooltip } from '@mui/material'
import { ReactComponent as CopyItemIcon } from 'assets/icons/CopyItem.svg';
import { toast } from 'react-toastify';
import { toastConfig } from 'config';


const CopyItemCell = (props) => {
    const { cell, column } = props
    const { meta } = column?.columnDef || {}

    const value = cell.getValue()

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(value).then(() => {
            toast(meta.tooltip, toastConfig)
            console.log('Copied to clipboard:', value);
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    }, [value])

    return (
        <CopyItemCellStyles>
            {!value ||
                <React.Fragment>
                    <Tooltip placement='top' title="העתקה">
                        <div className='email-and-icon'>
                            <IconButton size='small' onClick={handleCopy}>
                                <SvgIcon component={CopyItemIcon} inheritViewBox />
                            </IconButton>
                            {value}
                        </div>
                    </Tooltip>
                </React.Fragment>
            }
        </CopyItemCellStyles>
    )
}

export default CopyItemCell